var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('navigation-drawer',{attrs:{"propDrawer":_vm.drawer}}),_c('app-bar',{on:{"changeDrawer":_vm.changedDrawer}}),_c('v-main',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }